import { cva, type VariantProps } from 'class-variance-authority';
import styles from './button.module.css';

export type ButtonVariants = VariantProps<typeof variants>;

const variant = {
  primary: styles.primary,
  secondary: styles.secondary,
  destructive: styles.destructive,
  overlay: styles.overlay,
  text: styles.text,
  accent: styles.accent,
};

const size = {
  large: styles.large,
};

const fullWidth = {
  true: styles.fullwidth,
};

export const variantTypes = Object.keys(variant);

export const variants = cva(styles.button, {
  variants: {
    variant,
    size,
    fullWidth,
  },
  defaultVariants: {
    variant: 'primary',
  },
});
